import React, { useState, useEffect } from 'react';
import HttpService from '../../service/HttpService';
import { useNavigate } from 'react-router-dom';
import PrintReportButton from './PrintReportButton';


const ScanningSession = () => {
    const navigate = useNavigate();
    const { axiosInstance } = HttpService();
    const [sessions, setSessions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleView = (sessionId) => {
        navigate(`/dashboard/scanning-session/${sessionId}`);
    };

    // Fetch scanning sessions (same pattern as PreloadSection)
    const fetchSessions = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/scanning-sessions/snapshots');
            setSessions(response.data);
        } catch (error) {
            console.error('Failed to fetch scanning sessions:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSessions();
    }, []);

    return (
        <section className="dashboard-section">
            <div className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-6">Scanning Sessions</h2>
                {isLoading ? (
                    <div className="text-center">Loading...</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Delivery Notes</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Title</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Created By</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Created Date</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sessions.map(session => (
                                    <tr key={session.id} className="border-b">
                                        <td className="px-4 py-2">{session.deliveryNotes?.join(', ')}</td>
                                        <td className="px-4 py-2">{session.title}</td>
                                        <td className="px-4 py-2">{session.createdBy}</td>
                                        <td className="px-4 py-2">
                                            {session.createdDate
                                                ? new Intl.DateTimeFormat('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                }).format(new Date(session.createdDate))
                                                : ''}
                                        </td>
                                        <td className="px-4 py-2">
                                            {session.closed ? (
                                                <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">
                                                    Closed
                                                </span>
                                            ) : (
                                                <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700">
                                                    Open
                                                </span>
                                            )}
                                        </td>
                                        <td className="px-4 py-2 flex space-x-2"> {/* Add flex and spacing */}
                                            <button
                                                onClick={() => handleView(session.id)}
                                                className="bg-indigo-500 hover:bg-indigo-700 text-white text-xs font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline mr-2"
                                                title="View Details"
                                            >
                                                <i className="fas fa-eye mr-1"></i> View
                                            </button>
                                            <PrintReportButton sessionId={session.id} sessionTitle={session.title} />
                                        </td>
                                    </tr>
                                ))}
                                {sessions.length === 0 && (
                                    <tr>
                                        <td colSpan={6} className="text-center py-4 text-gray-400"> {/* Updated colSpan to 6 */}
                                            No scanning sessions found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ScanningSession;